"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const common_utils_1 = require("@zapier/common-utils");
const FieldComponentByType_1 = __importDefault(require("./FieldComponentByType"));
const FieldTypeHelpIcon_1 = __importDefault(require("../FieldTypeHelpIcon"));
const design_system_1 = require("@zapier/design-system");
const common_1 = require("../common");
const getFieldMapping_1 = require("./getFieldMapping");
const FieldHelpText_1 = __importDefault(require("./FieldHelpText"));
const theme_1 = require("@zapier/theme");
const useIsNewField_1 = __importDefault(require("./useIsNewField"));
const Styles = common_utils_1.labelStyles(__filename, {
    label: {
        marginRight: '0.3em',
    },
    root: {
        marginBottom: theme_1.Spacing.medium,
    },
});
const FORM = 'form';
const defaultProps = {
    canAddSearchStep: false,
    onAddSearchStep: lodash_1.noop,
    onConvertSearch: lodash_1.noop,
    onLoadOptions: lodash_1.noop,
    onToggleSilenceHook: lodash_1.noop,
    shouldFallbackToDefault: true,
    tag: FORM,
};
const FieldsForm = (_props) => {
    const props = Object.assign(Object.assign({}, defaultProps), _props);
    const { fields } = props;
    const isNewField = useIsNewField_1.default(fields);
    const fieldComponents = fields.map((field, i) => {
        const shouldFallbackToDefault = !props.metadata.isOpened || isNewField(field);
        const formProps = Object.assign(Object.assign({}, props), { shouldFallbackToDefault });
        const fieldProps = getFieldMapping_1.getFieldProps(field);
        const renderLabel = (labelProps) => (common_utils_1.isolateComponent(common_1.FormLabel, Object.assign({}, labelProps, { layout: "text-only", size: "small" }),
            common_utils_1.isolateComponent("span", null,
                common_utils_1.isolateComponent("span", { css: Styles.label }, labelProps.label),
                common_utils_1.isolateComponent(FieldTypeHelpIcon_1.default, { type: field.type }))));
        const key = field.key ? field.key : `fields-${i}`;
        return (common_utils_1.isolateComponent("div", { css: Styles.root, key: key }, fieldProps.hasFieldWrapper ? (common_utils_1.isolateComponent(design_system_1.Field, Object.assign({}, fieldProps, { helpTextLineClamp: 2, renderHelpText: () => common_utils_1.isolateComponent(FieldHelpText_1.default, { field: field }), renderInput: (inputProps) => (common_utils_1.isolateComponent(FieldComponentByType_1.default, { field: field, formProps: formProps, inputProps: inputProps })), renderLabel: renderLabel }))) : (common_utils_1.isolateComponent(FieldComponentByType_1.default, { field: field, formProps: formProps, inputProps: {
                id: field.key,
                isDisabled: fieldProps.isDisabled,
                isErrored: !!fieldProps.isErrored,
                isRequired: !!fieldProps.isRequired,
            } }))));
    });
    const Tag = props.tag;
    const onSubmit = (e) => e.preventDefault();
    const tagProps = Tag === FORM ? { onSubmit } : {};
    return common_utils_1.isolateComponent(Tag, Object.assign({}, tagProps), fieldComponents);
};
exports.default = FieldsForm;
